import { render, staticRenderFns } from "./ButtonDownload.vue?vue&type=template&id=7091d52a&scoped=true"
import script from "./ButtonDownload.vue?vue&type=script&lang=js"
export * from "./ButtonDownload.vue?vue&type=script&lang=js"
import style0 from "./ButtonDownload.vue?vue&type=style&index=0&id=7091d52a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7091d52a",
  null
  
)

export default component.exports